export enum Tenant {
  Candidate = 'candidate',
  Recruiter = 'recruiter',
  Client = 'client',
}
